/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

/*
 * Permissions
 */

/* global componentHandler, ANIMATIONS, globalData, CONTENT_TARGET, FormValidation, snackbar, runningMode */

/**
 * Use this to easy login the user. First call <i>Login.init()</i>.
 * User is logged in if <i>globalData.user</i> is not <i>null</i>.
 * To login or register User easy call <i>Login.login()</i>.
 * To logout call <i>Login.logput()</i>. <br>
 * Important: See the first functions in this object and implement them.
 * They are surrounded with comment <i>config start</i> and <i>contig end</i>.<br>
 * If you want to customize the menu html, see the function <i>_createLoginMenu</i>.
 * @type type
 */
var Login = {
  /* ---- config start ---- */
  /**
   * Check if user is already logged in with a session. It is important to
   * call all the functions from parameter.
   * @param {function} success
   * Call this if the user is already logged in.
   * @param {function} fail
   * Call this if the user is not logged in.
   * @param {function} done
   * Call this always before <i>success</i> and <i>fail</i>.
   * @returns {undefined}
   */
  _sessionCheck: function (success, fail, done) {
    done();
    fail();
    return;

    globalData.user = {
      id_user: "18",
      email: "k.klockgether@28apps.de",
      name: "Konrad Klockgether",
      date_of_birth: "1990-11-06",
    };
    done();
    success();
  },
  /**
   * Perform a login on server. It is important to call all the functions from parameter.
   * Note: For correct usage store your user data in <i>globalData.user</i>. The struckture
   * ist not important. They only should be not <i>null</i>.
   * @param {object} data
   * User input in form.
   * @param {function} success
   * Call this on a success login.
   * Closes the login menu.
   * @param {function} fail
   * Call this on a faild login.
   * @param {function} done
   * Call this always before <i>success</i> and <i>fail</i>.
   * @returns {undefined}
   */
  _login: function (data, success, fail, done) {
    globalData.user = {
      id_user: "18",
      email: "k.klockgether@28apps.de",
      name: "Konrad Klockgether",
      date_of_birth: "1990-11-06",
    };

    //show welcome message
    switch (runningMode.mode) {
      case runningMode.WEBVIEW:
        //do not show welcome message for that view
        break;
      default:
        var uName = globalData.user.name;
        snackbar.show({
          //show only the first name
          message: "Hallo " + (uName ? uName.split(" ")[0] : ""),
        });
    }

    done();
    success();
  },
  /**
   * Perform registration on server. It is important to call all the functions from parameter.
   * Note: For correct usage store your user data in <i>globalData.user</i>. The struckture
   * ist not important. They only should be not <i>null</i>.
   * @param {object} data
   * User input in form.
   * @param {function} success
   * Call this on a success login.
   * Closes the login menu.
   * @param {function} fail
   * Call this on a faild login.
   * @param {function} done
   * Call this always before <i>success</i> and <i>fail</i>.
   * @returns {undefined}
   */
  _signUp: function (data, success, fail, done) {
    globalData.user = {
      id_user: "18",
      email: "k.klockgether@28apps.de",
      name: "Konrad Klockgether",
      date_of_birth: "1990-11-06",
    };

    //show welcome message
    switch (runningMode.mode) {
      case runningMode.WEBVIEW:
        //do not show welcome message for that view
        break;
      default:
        var uName = globalData.user.name;
        snackbar.show({
          //show only the first name
          message: "Hallo " + (uName ? uName.split(" ")[0] : ""),
        });
    }

    done();
    success();
  },
  /**
   * Perform a request to server to send user a mail with an passwort reset link.
   * It is important to call all the functions from parameter.
   * Note: the <i>done</i> callback from <i>Login.login()</i> will not be called
   * here, because of not compleeted auth. If user close the menu or compleetes
   * the login, this callback will be called.
   * @param {function} success
   * Call this on successed mail sent.
   * This function shows a message to the user. The login menu will not be closed.
   * @param {function} fail
   * Call this if the mail could not be send.
   * This function shows a message to the user.
   * @returns {undefined}
   */
  _forgotPw: function (success, fail) {
    success();
  },
  /**
   * Perform a request to server to kill the session and logout the user.
   * It is important to call all the functions from parameter.
   * @param {function} success
   * Call this after logout succeeded.
   * Note: This function sets <i>globalData.user</i> to <i>null</i>
   * @param {function} fail
   * Call this if logout faild.
   * @param {function} done
   * Call this always before <i>success</i> and <i>fail</i>.
   * @returns {undefined}
   */
  _logout: function (success, fail, done) {
    //show welcome message
    switch (runningMode.mode) {
      case runningMode.WEBVIEW:
        //do not show welcome message for that view
        break;
      default:
        snackbar.show({
          message: "Tschüs! Und bis bald :)",
        });
    }

    done();
    success();
  },
  /**
   * Perform a request to server to login user with a token.
   * It is important to call all the functions from parameter.
   * @param {String} token
   * Token wich would be send to server and the user will be logged in with.
   * @param {function} success
   * Call this after logout succeeded.
   * @param {function} fail
   * Call this if logout faild.
   * @param {function} done
   * Call this always before <i>success</i> and <i>fail</i>.
   * @returns {undefined}
   */
  _byToken: function (token, success, fail, done) {
    /*done();
         fail();
         return;*/

    globalData.user = {
      id_user: "18",
      email: "k.klockgether@28apps.de",
      name: "Konrad Klockgether",
      date_of_birth: "1990-11-06",
    };

    //show welcome message
    switch (runningMode.mode) {
      case runningMode.WEBVIEW:
        //do not show welcome message for that view
        break;
      default:
        var uName = globalData.user.name;
        snackbar.show({
          //show only the first name
          message: "Hallo " + (uName ? uName.split(" ")[0] : ""),
        });
    }

    done();
    success();
  },
  /* ---- config end ---- */
  /**
   * Use this before calling any other function of <i>Login</i>.
   * This creates the login menu and checks if the user is already logged in.
   * @param {String} token
   * (optional) You could use this to login the user with a token.
   * @param {function} success
   * On succes login, this callback will be called without parameters.
   * To avoid view reload, put an empty function here.
   * @param {function} fail
   * If logout fails, this callback will be called without parameters.
   * @param {function} done
   * This will be called allways before <i>success</i> and <i>fail</i>
   * @returns {undefined}
   */
  init: function (token, success, fail, done) {
    var that = this;

    //attach login Menu to DOM
    this._node = this._createLoginMenu();

    //append here is important to calculate elements sizes for animations
    this._attach();
    componentHandler.upgradeDom();

    //change mode to login. If you don't change mode, all items of all modes will be visible.
    this._node.LM._changeMode("login");

    //try to login by token
    if (token) {
      this.loginByToken(
        token,
        success,
        function () {
          //if login by token faild, try to login with session
          that.loginBySession(success, fail, done);
        },
        done
      );
      return;
    }

    //check server session
    this.loginBySession(success, fail, done);
  },
  /**
   * Contains the login menu Element.
   * The Element should only be in DOM if user is not logged in.
   * @type type
   */
  _node: null,
  /**
   * Generates login menu element with functions and event listeners.
   * The Menu do not have logout functions.
   * It should be detached from DOM if user logged in.
   * The menu will not be attached to DOM.
   * @returns {Element}
   */
  _createLoginMenu: function () {
    var that = this;

    //create wrapper node
    var node = document.createElement("div");
    node.id = "loginMenu";

    /* --- create content from HTML --- */
    node.insertAdjacentHTML(
      "beforeend",
      '<form action="#">' +
        '<i class="material-icons close">close</i>' +
        '<h3 class="title">Login</h3>' +
        '<div class="input signup mdl-textfield mdl-js-textfield mdl-textfield--floating-label">' +
        '<input class="mdl-textfield__input" type="text" id="loginMenuFirstName" name="first_name">' +
        '<label class="mdl-textfield__label" for="loginMenuFirstName">Vorname</label>' +
        "</div>" +
        '<div class="input signup mdl-textfield mdl-js-textfield mdl-textfield--floating-label">' +
        '<input class="mdl-textfield__input" type="text" id="loginMenuLastName" name="last_name">' +
        '<label class="mdl-textfield__label" for="loginMenuLastName">Nachname</label>' +
        "</div>" +
        '<div class="input signup login forgotpw mdl-textfield mdl-js-textfield mdl-textfield--floating-label">' +
        '<input class="mdl-textfield__input" type="email" id="loginMenuEmail" name="email" required>' +
        '<label class="mdl-textfield__label" for="loginMenuEmail">E-Mail</label>' +
        "</div>" +
        '<div class="input signup login mdl-textfield mdl-js-textfield mdl-textfield--floating-label">' +
        '<input class="mdl-textfield__input" type="password" id="loginMenuPassword" name="password">' +
        '<label class="mdl-textfield__label" for="loginMenuPassword">Passwort (6-32 Zeichen)</label>' +
        "</div>" +
        '<a class="changeMode forgotpw">Passwort vergessen?</a>' +
        '<div class="input signup mdl-textfield mdl-js-textfield mdl-textfield--floating-label">' +
        '<input class="mdl-textfield__input" type="password" id="loginMenuPassword2" name="password2">' +
        '<label class="mdl-textfield__label" for="loginMenuPassword2">Passwort wiederholen</label>' +
        "</div>" +
        '<div class="input signup mdl-textfield mdl-js-textfield mdl-textfield--floating-label">' +
        '<input class="mdl-textfield__input" type="date" id="loginMenuDate_of_birth" name="birthdate">' +
        '<label class="mdl-textfield__label" for="loginMenuDate_of_birth">Geburtsdatum</label>' +
        "</div>" +
        '<label class="input signup mdl-checkbox mdl-js-checkbox" for="loginMenuAGB">' +
        '<input type="checkbox" id="loginMenuAGB" class="mdl-checkbox__input" name="agb">' +
        '<span class="mdl-checkbox__label">Hiermit akzeptiere ich die <a href="http://google.com/" target="_blank">AGB</a>' +
        "von Hummigbird.</span>" +
        "</label>" +
        '<button class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored mdl-js-ripple-effect">' +
        "Login" +
        "</button>" +
        '<div class="errorMessage">Hast was falsch gemacht</div>' +
        '<a class="changeMode signup">Oder registrieren Sie sich!</a>' +
        '<a class="changeMode login">Oder loggen Sie sich ein!</a>' +
        "</form>"
    );

    /* --- create content from HTML end --- */

    /* --- append functions --- */

    node.LM = {
      /**
       * Show login menu
       * @returns {undefined}
       */
      show: function () {
        node.classList.add("is-active");
      },
      /**
       * Hides menu and set inputs and mode to default
       * @returns {undefined}
       */
      hide: function () {
        this._hideErrorMessages();
        node.classList.remove("is-active");

        if (that._callbacks.done !== null) that._callbacks.done();

        //wait until hide animation is over and reset menu to default
        var timeout = window.getComputedStyle(node).transitionDuration;
        timeout = parseFloat(timeout) * 1000;
        setTimeout(function () {
          node.LM._clear();
          node.LM._changeMode("login");
        }, timeout);
      },
      /**
       * Show error label.
       * @param {String} errorMessage
       * Message to show.
       * @returns {undefined}
       */
      _showError: function (errorMessage) {
        if (errorMessage.length === 0) return;

        var errorLabel = node.querySelector("div.errorMessage");
        errorLabel.classList.add("is-active");
        errorLabel.classList.add("error");
        errorLabel.textContent = errorMessage;
      },
      /**
       * Show error label.
       * @param {String} message
       * Message to show.
       * @returns {undefined}
       */
      _showMessage: function (message) {
        if (message.length === 0) return;

        var errorLabel = node.querySelector("div.errorMessage");
        errorLabel.classList.add("is-active");
        errorLabel.textContent = message;
      },
      /**
       * Removes error class from all inputs. This hides the error indicators.
       * @returns {undefined}
       */
      _hideErrorMessages: function () {
        if (node.classList.contains("is-active")) {
          //search visible error messages
          var errors = node.querySelectorAll("input.error");
          //remove error class to hide hints
          for (var i = 0, len = errors.length; i < len; i++)
            errors[i].classList.remove("error");

          //hide message hint
          var msgHint = node.querySelector("div.errorMessage");
          msgHint.classList.remove("error");
          msgHint.classList.remove("is-active");
        }
      },
      /**
       * Show and hide some elements to change the mode. Also set the mode
       * in the dataset of loginMode.
       * @param {string} mode
       * 'signup', 'login', 'forgotpw'
       * @returns {undefined}
       */
      _changeMode: function (mode) {
        node.LM._hideErrorMessages();

        node.LM._mode = mode;

        var title = null;

        //default: hide all inputs exept the ones with mode as class. Also hide a.changeMode with mode es class
        var hideQuery = ".input:not(." + mode + "), a.changeMode." + mode;

        //default: show all inputs with mode as class. Also show all a.changeMode exept the one with mode as class
        var showQuery = ".input." + mode + ", a.changeMode:not(." + mode + ")";

        switch (mode) {
          case "signup":
            title = "Registrieren";
            hideQuery += ", a.changeMode.forgotpw";
            showQuery += ":not(.forgotpw)";
            break;
          case "login":
            title = "Einloggen";
            break;
          case "forgotpw":
            title = "Passwort wiederherstellen";
            hideQuery += ", a.changeMode.signup";
            showQuery += ":not(.signup)";
            break;
          default:
            console.error("mode " + mode + " not implemented");
        }

        var elementsToHide = node.querySelectorAll(hideQuery);
        var elementsToShow = node.querySelectorAll(showQuery);

        /* -- execute options -- */

        //change labels
        node.querySelector(".title").textContent = title;
        node.querySelector("button").textContent = title;

        //set validation props
        for (var i = 0, len = elementsToHide.length; i < len; i++) {
          var item = elementsToHide[i];

          if (!item.classList.contains("input")) continue;

          item = item.children[0]; //should be the input
          item.required = false;
        }
        for (var i = 0, len = elementsToShow.length; i < len; i++) {
          var item = elementsToShow[i];

          if (!item.classList.contains("input")) continue;

          item = item.children[0]; //should be the input
          item.required = true;
        }

        //show/hide elements
        ANIMATIONS.SLIDE_UP(elementsToHide);
        ANIMATIONS.SLIDE_DOWN(elementsToShow);
      },
      /**
       * Removes all values from inputs in login menu. Also removes all error indicators.
       * @returns {undefined}
       */
      _clear: function () {
        //clear all inputs
        var inputs = node.querySelectorAll("input");
        for (var i = 0, len = inputs.length; i < len; i++) {
          var input = inputs[i];
          switch (input.type) {
            case "checkbox":
              input.checked = false;
              input.parentNode.classList.remove("is-checked");
              break;
            default:
              input.value = null;
          }
        }

        //remove error hints
        this._hideErrorMessages();
      },
      /**
       *
       * @param {Object} data
       * @returns {undefined}
       */
      submit: function (data) {
        //call user configurated functions to perform action
        switch (this._mode) {
          case "login":
            that._login(
              data,
              that._callbacks.success,
              function (msg) {
                if (!msg) msg = "Login nicht möglich.";
                node.LM._showError(msg);
              },
              that._callbacks.done
            );
            break;
          case "signup":
            that._signUp(
              data,
              that._callbacks.success,
              function (msg) {
                if (!msg) msg = "Registrierung nicht möglich.";
                node.LM._showError(msg);
              },
              that._callbacks.done
            );
            break;
          case "forgotpw":
            //do not call any callbacks, because the login is not compleete or faild
            that._forgotPw(
              function () {
                //On successeded password reset, set mode to login and show user a message.
                node.LM._changeMode("login");
                node.LM._showMessage(
                  "Eine E-Mail zur Passwortwiederherstellung wurde an Sie versendet. Setzten Sie das Passwort neu und loggen Sie sich ein."
                );
              },
              function () {
                //If password reset fails, show user an error message.
                node.LM._showError(
                  "Eine E-Mail zur Passwort wiederherstellung konnte nicht versendet werden."
                );
              }
            );
            break;
          default:
            console.error("mode " + this._mode + " not implemented");
        }
      },
    };

    /* --- append functions end --- */

    /* --- bind event listener --- */

    //change modes
    node
      .querySelector("a.changeMode.signup")
      .addEventListener("click", function () {
        node.LM._changeMode("signup");
      });
    node
      .querySelector("a.changeMode.login")
      .addEventListener("click", function () {
        node.LM._changeMode("login");
      });
    node
      .querySelector("a.changeMode.forgotpw")
      .addEventListener("click", function () {
        node.LM._changeMode("forgotpw");
      });

    //close
    node.querySelector(".close").addEventListener("click", function () {
      that._abort();
    });
    node.addEventListener("click", function (e) {
      //hide only if user clicked on the overlay
      if (this === e.target) that._abort();
    });

    //pw2 check
    var pwInput = node.querySelector("input[name=password]");
    var pwInput2 = node.querySelector("input[name=password2]");
    FormValidation.equalInputs(pwInput, pwInput2);

    //form submit
    node.onsubmit = function (e) {
      e.preventDefault();

      //collect data
      var data = FormValidation.serializeForm(e.srcElement);

      node.LM.submit(data);
    };

    /* --- bind event listener end --- */

    /* --- initialize some stuff --- */

    //init date input
    new DatePicker(node.querySelector("input[name=birthdate]"), {
      years: {
        from: 1920,
        to: 2005,
      },
    });

    /* --- initialize some stuff end --- */

    return node;
  },
  /**
   * Append LoginMenu to DOM. If not already created, it will be now.
   * @returns {undefined}
   */
  _attach: function () {
    //append to DOM. MDL upgrade is not necessary
    document.body.appendChild(this._node);
  },
  /**
   * Removes LoginMenu from DOM. The element will keep in <i>LoginMenu._node</i>.
   * @returns {undefined}
   */
  _detach: function () {
    var that = this;

    //hide menu
    this._node.LM.hide();

    //wait until hide animation is over and detach menu from DOM
    var timeout = window.getComputedStyle(this._node).transitionDuration;
    timeout = parseFloat(timeout) * 1000;
    setTimeout(function () {
      document.body.removeChild(that._node);
    }, timeout);
  },
  /**
   * Hides the menu and call fail and done callbacks
   */
  _abort: function () {
    //hide menu
    this._node.LM.hide();

    //call callbacks
    this._callbacks.done();
    this._callbacks.fail();
  },
  /**
   * Easy to use function to login or signup user.
   * @param {function} success
   * If login succes, this callback will be called without parameters.
   * To avoid view reload, put an empty function here.
   * @param {function} fail
   * If login fails, this callback will be called without parameters.
   * @param {function} done
   * This will be called allways before <i>success</i> and <i>fail</i>
   * @returns {undefined}
   */
  login: function (success, fail, done) {
    var that = this;

    //user already logged in?
    if (globalData.user !== null) {
      if (typeof done === "function") done();
      if (typeof success === "function") success();
      return;
    }

    //save callbacks. Check type on this step
    this._callbacks.success = function () {
      //remove the menu element from dom to keep it small
      that._detach();

      that._privateDrawerLinks(true);

      if (typeof success === "function") success();
      //if you using hummingbird, you should use this line to reload the current view for default
      else CONTENT_TARGET.reloadView();
    };
    this._callbacks.fail = function () {
      if (typeof fail === "function") fail();
    };
    this._callbacks.done = function () {
      if (typeof done === "function") done();
    };

    //show login menu
    this._node.LM.show();
  },
  /**
   * Easy to use function to logout user.
   * @param {function} success
   * If logout succes, this callback will be called without parameters.
   * To avoid view reload, put an empty function here.
   * @param {function} fail
   * If logout fails, this callback will be called without parameters.
   * @param {function} done
   * This will be called allways before <i>success</i> and <i>fail</i>
   * @returns {undefined}
   */
  logout: function (success, fail, done) {
    var that = this;

    //user not logged in?
    if (globalData.user === null) {
      if (typeof done === "function") done();
      if (typeof success === "function") success();
      return;
    }

    //logout with configurated function
    this._logout(
      function () {
        //set user to null to be able to check if user is logged in or not.
        //Also to keep his data private from other users.
        globalData.user = null;

        that._privateDrawerLinks(false);

        //attach the login menu back to DOM for fast show
        that._attach();

        if (typeof success === "function") success();
        //if you using hummingbird, you should use this line to reload the current view for default
        else CONTENT_TARGET.reloadView();
      },
      function () {
        if (typeof fail === "function") fail();
      },
      function () {
        if (typeof done === "function") done();
      }
    );
  },
  /**
   * Login user with token.
   * @param {String} token
   * Token wich would be send to server and the user will be logged in with.
   * @param {function} success
   * On succes login, this callback will be called without parameters.
   * To avoid view reload, put an empty function here.
   * @param {function} fail
   * If logout fails, this callback will be called without parameters.
   * @param {function} done
   * This will be called allways before <i>success</i> and <i>fail</i>
   * @returns {undefined}
   */
  loginByToken: function (token, success, fail, done) {
    var that = this;

    //login with configurated function
    this._byToken(
      token,
      function () {
        //attach the login menu back to DOM for fast show
        that._detach();

        that._privateDrawerLinks(true);

        if (typeof success === "function") success();
        //if you using hummingbird, you should use this line to reload the current view for default
        else CONTENT_TARGET.reloadView();
      },
      function () {
        if (typeof fail === "function") fail();
      },
      function () {
        if (typeof done === "function") done();
      }
    );
  },
  /**
   * Check if user has already a session on server.
   * @param {function} success
   * On succes login, this callback will be called without parameters.
   * To avoid view reload, put an empty function here.
   * @param {function} fail
   * If logout fails, this callback will be called without parameters.
   * @param {function} done
   * This will be called allways before <i>success</i> and <i>fail</i>
   * @returns {undefined}
   */
  loginBySession: function (success, fail, done) {
    var that = this;

    //login with configurated function
    this._sessionCheck(
      function () {
        //attach the login menu back to DOM for fast show
        that._detach();

        that._privateDrawerLinks(true);

        if (typeof success === "function") success();
        //if you using hummingbird, you should use this line to reload the current view for default
        else CONTENT_TARGET.reloadView();
      },
      function () {
        if (typeof fail === "function") fail();
      },
      function () {
        if (typeof done === "function") done();
      }
    );
  },
  /**
   * Shows or hide links to private views in MDL drawer.
   * @param {boolean} show
   * <i>true</i> to show private members. <i>false</i> to hide.
   * @returns {undefined}
   */
  _privateDrawerLinks: function (show) {
    var newState = show ? "block" : "none";

    var privateMenuElements = document.querySelectorAll(
      ".mdl-layout__drawer nav a.private"
    );
    for (var i = 0, len = privateMenuElements.length; i < len; i++)
      privateMenuElements[i].style.display = newState;
  },
  /**
   * Stores the callbacks for calling after <i>Login.login()</i>.
   */
  _callbacks: {
    success: null,
    fail: null,
    done: null,
  },
};
